// Pioneer Custom — Scroll Reveal Animation
//
// CSS (pioneer-custom.css):
//   .reveal          → opacity: 0, translateY(40px)
//   .reveal.visible  → opacity: 1, translateY(0)
//
// This script adds `.visible` to `.reveal` elements as they scroll into view.
// Two safety nets to prevent products ever being stuck invisible:
//   1. Generous rootMargin so elements near the fold trigger immediately on load.
//   2. Hard fallback: after 800ms, any still-hidden .reveal gets .visible
//      applied no matter what. If JS or IntersectionObserver hiccups for any
//      reason, the content shows up rather than staying stuck at opacity:0.
(function () {
  function showAll() {
    var all = document.querySelectorAll('.reveal:not(.visible)');
    for (var i = 0; i < all.length; i++) {
      all[i].classList.add('visible');
    }
  }

  function init() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;

    // Fallback timer — guarantees nothing stays stuck at opacity:0 forever,
    // even if IntersectionObserver misses something (e.g. sections swapped
    // after initial scan, or JS error elsewhere on the page).
    setTimeout(showAll, 800);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.05,
        // Treat elements up to 25% of viewport height BELOW the fold as
        // already intersecting. Anything "about to come into view" fades
        // in on first paint instead of waiting for the user to scroll.
        rootMargin: '0px 0px 25% 0px',
      });
      els.forEach(function (el) { observer.observe(el); });
    } else {
      showAll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
